<app-material>
    <div class="header" header>
        <h2>{{ 'admin.toolsUsage.title' | translate }}</h2>
        <app-icon library="material" variant="filter_list" (click)="toggleFilters()"></app-icon>
    </div>
    <ng-container body>
        <app-tools-usage-table
            [toolsGrouped]="toolsGrouped"
            [isLoading]="isLoadingTools"
            [tableConfig]="tableConfig"
            [showGroupFilters]="true"
            [showGroupers]="false"
            [hasTitle]="false"
            [notMyProblem]="true"
            [showFilters]="isFilterExpanded"
            [isFilterExpanded]="isFilterExpanded"
            [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
            [filterBySecLinesId]=filterBySecLinesId
            (sortChange)="onSortChange($event)"
            (filterChange)="onFilterChange($event)"
            (filterGroupChange)="onFilterGroupChange($event)"
            (pageChange)="onPageChange($event)"
            (openDetais)="openToolDetails($event)"
            (openDetailsNewPage)="openToolDetailsNewPage($event)"
            (openTicket)="onOpenTicket($event)"
            (openRevisionModal)="onOpenRevisionModal($event)">
        </app-tools-usage-table>
    </ng-container>

</app-material>
<app-ticket-details-modal (closeTicket)="onCancelTicket($event)"
                          (downloadFile)="onDownloadFile($event)"></app-ticket-details-modal>
<app-confirmation-modal (scanEvent)="confirmCancelTicket($event)"
                        title="{{'atom.tickets.closeTicketPopup.popupTitle' | translate}}"
                        question="{{'atom.tickets.closeTicketPopup.popupQuestion' | translate}}"
                        message="{{'atom.tickets.closeTicketPopup.popupMessage' | translate}}"
                        [displayReasonMode]="false">
</app-confirmation-modal>
<app-recurrence-modal
    title="{{'admin.toolsUsage.revisionInfo.modal.title' | translate}}">
</app-recurrence-modal>
